<div class="err-page-blank-app-body">

  <div class="row">
    <div class="col-lg-8">
      <div class="err-page-blank-app err-page-blank-header">
        <h1> We're sorry</h1>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="err-page-blank-app">
        <p class="lead">Unfortunately, we’re unable to load the page you were trying to access.</p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-push-12">
      <div class="err-page-blank-app">
        <ul>
          <li>
            If you are accessing the application from a desktop computer, we recommend using
            <a [href]="chromeURL" target="_blank">Google Chrome</a> or
            <a [href]="fireFoxURL" target="_blank">Mozilla Firefox</a>
            internet browsers for optimal user experience. Even if you tried to access the application from one of these browsers,
            it can be helpful to try and log in from a different browser (simply copy and paste the URL above into the new browser window)
          </li>
          <li>
            Alternatively, you can wait a few minutes and try <a href="#" (click)="goToCustomerAuthPage($event)">logging in</a> again from your current browser
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>
